export default __webpack_public_path__ + "static/media/ww2.55a95a3d.jpg";